<template>
    <transition name="modal-fade">
        <div class="modal-component-backdrop">
            <div class="modal-component  rounded-8" role="dialog" aria-labelledby="modalTitle"
                aria-describedby="modalDescription">
                <div class="modal-component-body">
                    <createbootcamp-component
                        :get_url="url_get"
                        :current_bootcamp="bootcamp"
                        @oncancel="closeModal"
                        @onsaved="refreshBootcamps"
                        v-if="is_super_admin"
                    ></createbootcamp-component>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: ['url_get', 'is_super_admin', 'bootcamp'],
    methods: {
        closeModal() {
            this.$emit('onCancel');
        },
        refreshBootcamps() {
            this.$emit('onRefresh');
        }
    }
};
</script>

<style>
.modal-component-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
}

.modal-component {
    background: #FFFFFF;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    min-width: 60vw;
}

@media(max-width: 576px){
    .modal-component{
        min-width: 90vw;
    }
}

.modal-component-header,
.modal-component-footer {
    padding: 15px;
    display: flex;
}

.modal-component-header {
    position: relative;
    border-bottom: 1px solid #eeeeee;
    color: #4AAE9B;
    justify-content: space-between;
}

.modal-component-footer {
    border-top: 1px solid #eeeeee;
    /*flex-direction: column;*/
    justify-content: flex-end;
    background: none !important;
}

.modal-component-body {
    position: relative;
    padding: 20px 10px;
}

.modal-fade-enter,
.modal-fade-leave-to {
    opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
    transition: opacity .5s ease;
}</style>
